import Typography from 'common/components/Typography'
import {
  M_RFQ_URL,
  NEWS_URL,
  WEB_DESKTOP_RALALI_URL,
} from 'common/constants'
import React from 'react'
import ISeeAllButton from 'services/Search/components/SeeAllButton/interface'
import styled from 'styled-components'

const StyledSeeAll = styled.div`
  cursor: pointer;
`
const SeeAllButtonWrappper = ({
  code,
  keyword,
  children,
}: ISeeAllButton): JSX.Element => {
  const seeAllButton = {
    item: () => {
      window.location.assign(
        `${WEB_DESKTOP_RALALI_URL}/search/${keyword}`,
      )
    },
    seller: () => {
      window.location.assign(
        `${WEB_DESKTOP_RALALI_URL}/search/${keyword}?tab=store`,
      )
    },
    digitalgoods: () => {
      window.location.assign(`${WEB_DESKTOP_RALALI_URL}/billing`)
    },
    tender: () => {
      window.location.assign(`${M_RFQ_URL}/tender/live-request`)
    },
    pavilion: () => {
      window.location.assign(`${WEB_DESKTOP_RALALI_URL}/pavilion/`)
    },
    faq: () => {
      window.location.assign(
        `${WEB_DESKTOP_RALALI_URL}/docs/search?query=${keyword}&searchType=articles`,
      )
    },
    news: () => {
      window.location.assign(`${NEWS_URL}/?s=${keyword}`)
    },
  }

  return (
    <StyledSeeAll
      onClick={seeAllButton[code]}
      data-testid="see-all-button"
    >
      <Typography fontSize="10px" fontWeight="bold" color="orange">
        {children}
      </Typography>
    </StyledSeeAll>
  )
}

export default SeeAllButtonWrappper
